import React, { useMemo } from 'react';
import { BillingHistoryController, BillingHistoryControllerProps } from './BillingHistory.controller';
import { useSelectedOrganization } from '../../../hooks/useSelectedOrganization';
import { Invoice, useGetInvoicesAndBillingQuery } from '../../../models/graphql';
import { gql } from '@apollo/client';
import { cloneDeep } from '@apollo/client/utilities';

gql`
  query getInvoicesAndBilling($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      invoices {
        ...CoreInvoiceFields
        billingAddressDetails {
          ...CoreBillingAddressDetailsFields
        }
        businessAddressDetails {
          ...CoreBusinessAddressDetailsFields
        }
        vatBusinessDetails {
          ...CoreVatBusinessDetailFields
        }
        creditCard {
          ...CoreCreditCardFields
        }
      }
    }
  }
`;
export const BillingHistoryApollo = (): JSX.Element => {
  const { selectedOrganization } = useSelectedOrganization();
  const { error, loading, data } = useGetInvoicesAndBillingQuery({
    variables: {
      organizationId: selectedOrganization?.id || ''
    }
  });

  if (error) {
    // ...
  }

  const invoices: Invoice[] = useMemo(() => {
    const clonedInvoices = cloneDeep(data?.organization?.invoices) || [];

    return clonedInvoices.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);

      // Some basic error handling
      if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
      if (isNaN(dateA.getTime())) return 1;
      if (isNaN(dateB.getTime())) return -1;

      // Ascending order:
      // return dateA.getTime() - dateB.getTime();
      // Descending order:
      return dateB.getTime() - dateA.getTime();
    });
  }, [data?.organization?.invoices]);

  const controllerProps: BillingHistoryControllerProps = {
    loading,
    invoices
  };

  return <BillingHistoryController {...controllerProps} />;
};
